import { useState, useEffect } from 'react'
import { useAuth } from '../hooks/useAuth'
import { Navigate } from 'react-router-dom'
import { getIPTVLists, addIPTVList, deleteIPTVList } from '../services/iptvLists'
import { clearCache } from '../services/iptv'
import Loader from '../components/common/Loader'
import './AdminIPTV.css'

const ADMIN_UID = 'bdvqas1HoJP7Q4gop9mHqyvNtbu2'

function AdminIPTV() {
  const { user } = useAuth()
  const [lists, setLists] = useState([])
  const [loading, setLoading] = useState(true)
  const [newName, setNewName] = useState('')
  const [newUrl, setNewUrl] = useState('')
  const [adding, setAdding] = useState(false)
  const [deleting, setDeleting] = useState(null)

  // Check admin access
  if (user?.uid !== ADMIN_UID) {
    return <Navigate to="/" replace />
  }

  useEffect(() => {
    loadLists()
  }, [])

  const loadLists = async () => {
    setLoading(true)
    const data = await getIPTVLists()
    setLists(data)
    setLoading(false)
  }

  const handleAddList = async (e) => {
    e.preventDefault()
    if (!newName.trim() || !newUrl.trim()) return
    
    setAdding(true)
    const result = await addIPTVList(newName.trim(), newUrl.trim())
    if (result) {
      setLists([...lists, result])
      setNewName('')
      setNewUrl('')
      clearCache() // Force reload of channels
    }
    setAdding(false)
  }

  const handleDeleteList = async (listId) => {
    if (!confirm('¿Eliminar esta lista?')) return
    
    setDeleting(listId)
    const success = await deleteIPTVList(listId)
    if (success) {
      setLists(lists.filter(l => l.id !== listId))
      clearCache() // Force reload of channels
    }
    setDeleting(null)
  }

  return (
    <div className="admin-iptv-page container">
      <h1>📺 Administrar Listas IPTV</h1>
      
      {/* Add new list form */}
      <form className="add-list-form" onSubmit={handleAddList}>
        <input
          type="text"
          placeholder="Nombre (ej: 🇪🇸 España)"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          className="form-input"
        />
        <input
          type="url"
          placeholder="URL de la lista M3U"
          value={newUrl}
          onChange={(e) => setNewUrl(e.target.value)}
          className="form-input url-input"
        />
        <button 
          type="submit" 
          className="btn btn-primary"
          disabled={adding || !newName || !newUrl}
        >
          {adding ? 'Añadiendo...' : '➕ Añadir'}
        </button>
      </form>

      {/* Lists table */}
      {loading ? (
        <Loader />
      ) : lists.length === 0 ? (
        <p className="no-lists">No hay listas configuradas</p>
      ) : (
        <div className="lists-table">
          <div className="table-header">
            <span>Nombre</span>
            <span>URL</span>
            <span>Acciones</span>
          </div>
          {lists.map(list => (
            <div key={list.id} className="table-row">
              <span className="list-name">{list.name}</span>
              <span className="list-url">{list.url}</span>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleDeleteList(list.id)}
                disabled={deleting === list.id}
              >
                {deleting === list.id ? '...' : '🗑️'}
              </button>
            </div>
          ))}
        </div>
      )}
      
      <p className="hint">
        💡 Los cambios se aplicarán la próxima vez que se cargue la página de TV en vivo.
      </p>
    </div>
  )
}

export default AdminIPTV
